var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2611 0H2.73164C1.22129 0 0 1.16016 0 2.59453V33.3984C0 34.8328 1.22129 36 2.73164 36H34.2611C35.7715 36 37 34.8328 37 33.4055V2.59453C37 1.16016 35.7715 0 34.2611 0ZM10.9771 30.6773H5.48496V13.493H10.9771V30.6773ZM8.23105 11.1516C6.46777 11.1516 5.04414 9.76641 5.04414 8.05781C5.04414 6.34922 6.46777 4.96406 8.23105 4.96406C9.98711 4.96406 11.4107 6.34922 11.4107 8.05781C11.4107 9.75937 9.98711 11.1516 8.23105 11.1516ZM31.5295 30.6773H26.0445V22.3242C26.0445 20.3344 26.0084 17.768 23.19 17.768C20.3355 17.768 19.902 19.9406 19.902 22.1836V30.6773H14.4242V13.493H19.6852V15.8414H19.7574C20.4873 14.4914 22.2795 13.0641 24.9461 13.0641C30.5033 13.0641 31.5295 16.6219 31.5295 21.2484V30.6773Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.77e12e7e.svg";
export { ForwardRef as ReactComponent };